import React from 'react';

const Texto = ({ pregunta, answer, onAnswer }) => {
  const text = answer?.text ?? '';
  const { multilinea, placeholder, maxLength } = pregunta;

  const commonCls =
    'w-full px-3 py-2.5 border-2 border-gray-200 rounded-xl text-sm outline-none focus:border-red-400 transition-colors bg-white placeholder-gray-300';

  return multilinea ? (
    <textarea
      className={commonCls}
      rows={3}
      placeholder={placeholder || ''}
      maxLength={maxLength || 500}
      value={text}
      onChange={e => onAnswer({ text: e.target.value })}
      onKeyDown={e => e.stopPropagation()}
    />
  ) : (
    <input
      type="text"
      className={commonCls}
      placeholder={placeholder || ''}
      maxLength={maxLength || 100}
      value={text}
      onChange={e => onAnswer({ text: e.target.value })}
      onKeyDown={e => e.stopPropagation()}
    />
  );
};

export default Texto;
